import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export function Badge({ className, variant, ...props }: HTMLAttributes<HTMLSpanElement> & { variant?: "secondary" | "outline" }) {
  return <span className={cn("inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold", variant === "secondary" && "bg-secondary text-secondary-foreground", variant === "outline" && "border bg-background", className)} {...props} />;
}
